module.exports = __webpack_public_path__ + "static/img/52.e51c8cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/52.png
// module id = HRxu
// module chunks = 1